"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = emptyThrows;
function emptyThrows(x, message) {
    if (x.length === 0) {
        throw new Error(message);
    }
    return x;
}
//# sourceMappingURL=emptyThrows.js.map